import React from "react";
import "../style/ContactSection.css";

export default function ContactSection() {
  return (
    <section className="contact-wrapper">
      {/* Декоративные яркие пятна на фоне */}
      <div className="bg-glow spot-1"></div>
      <div className="bg-glow spot-2"></div>

      <div className="container">
        <div className="text-block">
          <h1 className="brand-title">BilPay</h1>
          <h2 className="sub-title">Ваш капитал в движении</h2>
          <p className="description">
            <span className="highlight">BilPay</span> – инновационная платформа для мгновенных расчетов. 
            Мы объединили скорость, безопасность и интуитивный интерфейс, чтобы управление 
            вашими финансами стало проще и ярче.
          </p>
          <div className="status-badge">
            <span className="dot"></span> Все системы работают стабильно
          </div>
        </div>

        <div className="image-block">
          <div className="image-glow"></div>
          {/* Замените exchage.png на ваше изображение */}
          {/* <img src="./exchange.png" alt="BilPay interface" className="main-illustration" /> */}
        </div>
      </div>

      <footer className="footer">
        <div className="footer-content">
          <div className="footer-left">
             <div className="footer-logo">Bil<span>Pay</span></div>
          </div>

          <div className="footer-center">
            <p>© 2025 BilPay. Лицензированный финансовый сервис.</p>
            <div className="footer-links">
              <a href="#">Конфиденциальность</a>
              <a href="#">Публичная оферта</a>
            </div>
          </div>

          <div className="footer-right">
            <a href="#" className="social-icon wa">WA</a>
            <a href="#" className="social-icon tg">TG</a>
          </div>
        </div>
      </footer>
    </section>
  );
}